/* The Blue Line – Landingpage. Gehört zu sections/blue-line-landing.liquid.
   Alle Texte stehen im HTML, damit Weglot sie übersetzt. Dieses Skript blendet nur ein und aus
   und schreibt Zahlen in Spans mit .notranslate / data-wg-notranslate. */
(function () {
  'use strict';

  var GOAL = 42.195;
  var STORE_KEY = 'blueLineRuns';

  function each(list, fn) {
    for (var i = 0; i < list.length; i++) fn(list[i], i);
  }
  function locale() {
    try {
      if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
        var wl = window.Weglot.getCurrentLang();
        if (wl) return wl;
      }
    } catch (e) {}
    return document.documentElement.getAttribute('lang') || 'de';
  }
  function fmt(n, minD, maxD) {
    try {
      return new Intl.NumberFormat(locale(), { minimumFractionDigits: minD, maximumFractionDigits: maxD }).format(n);
    } catch (e) {
      var f = Math.pow(10, maxD);
      return String(Math.round(n * f) / f);
    }
  }
  function dateFmt(d, opts) {
    try {
      return new Intl.DateTimeFormat(locale(), opts).format(d);
    } catch (e) {
      return d.toLocaleDateString();
    }
  }
  function setAll(scope, sel, text) {
    each(scope.querySelectorAll(sel), function (el) {
      el.textContent = text;
    });
  }

  /* KM 5: Etikett-Karten aufklappen */
  function initToggles(root) {
    each(root.querySelectorAll('[data-bl-toggle]'), function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (panel) panel.hidden = !open;
        var card = btn.closest('[data-bl-card]');
        if (card) card.classList.toggle('is-open', open);
        each(btn.querySelectorAll('[data-when]'), function (s) {
          s.hidden = s.getAttribute('data-when') !== (open ? 'open' : 'closed');
        });
      });
    });
  }

  /* KM 21,1: Espresso-Rechner */
  function initCalc(root) {
    var calc = root.querySelector('[data-bl-calc]');
    if (!calc) return null;
    var shot = parseFloat(root.getAttribute('data-shot')) || 32.5;
    var dose = parseFloat(root.getAttribute('data-dose')) || 19;
    var bag = parseFloat(root.getAttribute('data-bag')) || 250;
    var dist = 42.195;
    var inH = calc.querySelector('[data-calc="h"]');
    var inM = calc.querySelector('[data-calc="m"]');
    var inS = calc.querySelector('[data-calc="s"]');
    var hasEl = calc.querySelector('[data-has-time]');
    var noEl = calc.querySelector('[data-no-time]');
    var pills = calc.querySelectorAll('[data-dist]');

    function num(el, max) {
      var v = parseInt(el && el.value, 10);
      if (isNaN(v) || v < 0) return 0;
      return v > max ? max : v;
    }
    function render() {
      var sec = num(inH, 24) * 3600 + num(inM, 59) * 60 + num(inS, 59);
      var has = sec > 0;
      if (hasEl) hasEl.hidden = !has;
      if (noEl) noEl.hidden = has;
      if (!has) return;
      var shots = Math.round(sec / shot);
      var grams = shots * dose;
      var pace = sec / dist;
      var pm = Math.floor(pace / 60);
      var ps = Math.round(pace - pm * 60);
      if (ps === 60) {
        pm += 1;
        ps = 0;
      }
      setAll(calc, '[data-out="shots"]', fmt(shots, 0, 0));
      setAll(calc, '[data-out="kg"]', fmt(Math.round(grams / 100) / 10, 1, 1));
      setAll(calc, '[data-out="bags"]', fmt(Math.round(grams / bag), 0, 0));
      setAll(calc, '[data-out="pace"]', pm + ':' + (ps < 10 ? '0' : '') + ps);
      setAll(calc, '[data-out="perkm"]', fmt(Math.round((shots / dist) * 10) / 10, 1, 1));
    }
    each(pills, function (pill) {
      pill.addEventListener('click', function () {
        dist = parseFloat(pill.getAttribute('data-dist')) || 42.195;
        each(pills, function (p) {
          var on = p === pill;
          p.classList.toggle('is-on', on);
          p.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        render();
      });
    });
    each([inH, inM, inS], function (el) {
      if (el) el.addEventListener('input', render);
    });
    render();
    return render;
  }

  /* KM 38: Marathon in Raten. Speichert nur im Browser (localStorage), nichts geht an uns. */
  function monthKey(d) {
    var m = d.getMonth() + 1;
    return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m;
  }
  function monthLabel(key) {
    var p = String(key).split('-');
    return dateFmt(new Date(+p[0], +p[1] - 1, 1), { month: 'long', year: 'numeric' });
  }
  function load() {
    try {
      var raw = window.localStorage.getItem(STORE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }
  function save(data) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch (e) {}
  }
  function sum(runs) {
    var t = 0;
    each(runs, function (r) {
      t += +r.km || 0;
    });
    return Math.round(t * 1000) / 1000;
  }

  function initTracker(root) {
    var tr = root.querySelector('[data-bl-tracker]');
    if (!tr) return null;
    var cur = monthKey(new Date());
    var data = load();
    if (!data || typeof data !== 'object' || !Array.isArray(data.runs)) {
      data = { month: cur, runs: [], lastMonth: null };
    }
    if (data.month !== cur) {
      if (data.runs.length) data.lastMonth = { month: data.month, total: sum(data.runs) };
      data.month = cur;
      data.runs = [];
      save(data);
    }

    var form = tr.querySelector('[data-t-form]');
    var input = tr.querySelector('[data-t-input]');
    var err = tr.querySelector('[data-t-error]');
    var list = tr.querySelector('[data-t-list]');
    var proto = tr.querySelector('[data-t-proto]');
    var reset = tr.querySelector('[data-t-reset]');
    var fill = tr.querySelector('[data-t-fill]');
    var bar = tr.querySelector('[role="progressbar"]');
    var done = tr.querySelector('[data-t-done]');
    var remWrap = tr.querySelector('[data-t-remaining-wrap]');
    var last = tr.querySelector('[data-t-last]');
    var armed = false;

    function setArmed(on) {
      armed = on;
      if (!reset) return;
      each(reset.querySelectorAll('[data-when]'), function (s) {
        s.hidden = s.getAttribute('data-when') !== (on ? 'confirm' : 'idle');
      });
    }
    function removeRun(id) {
      data.runs = data.runs.filter(function (r) {
        return r.id !== id;
      });
      save(data);
      render();
    }
    function render() {
      var total = sum(data.runs);
      var finished = total >= GOAL;
      setAll(tr, '[data-t-month]', monthLabel(data.month));
      setAll(tr, '[data-t-total]', fmt(total, 0, 2));
      setAll(tr, '[data-t-remaining]', fmt(Math.max(GOAL - total, 0), 0, 3));
      if (fill) fill.style.width = Math.min(total / GOAL, 1) * 100 + '%';
      if (bar) bar.setAttribute('aria-valuenow', String(Math.min(total, GOAL)));
      if (done) done.hidden = !finished;
      if (remWrap) remWrap.hidden = finished;
      each(tr.querySelectorAll('[data-ms]'), function (li) {
        var reached = total >= parseFloat(li.getAttribute('data-ms'));
        li.classList.toggle('is-done', reached);
        var dot = li.querySelector('.bl-dot');
        if (dot) dot.classList.toggle('on', reached);
      });
      if (list && proto) {
        each(list.querySelectorAll('li:not([data-t-proto])'), function (li) {
          li.parentNode.removeChild(li);
        });
        each(data.runs.slice().reverse(), function (run) {
          var li = proto.cloneNode(true);
          li.removeAttribute('data-t-proto');
          li.hidden = false;
          setAll(li, '[data-t-date]', dateFmt(new Date(run.date), { day: 'numeric', month: 'short' }));
          setAll(li, '[data-t-km]', fmt(run.km, 0, 2));
          var rm = li.querySelector('[data-t-remove]');
          if (rm) {
            rm.addEventListener('click', function () {
              removeRun(run.id);
            });
          }
          list.appendChild(li);
        });
        list.hidden = data.runs.length === 0;
      }
      if (reset) reset.hidden = data.runs.length === 0;
      setArmed(false);
      if (last) {
        var lm = data.lastMonth;
        var show = !!(lm && lm.month);
        last.hidden = !show;
        if (show) {
          setAll(last, '[data-t-last-month]', monthLabel(lm.month));
          setAll(last, '[data-t-last-km]', fmt(+lm.total || 0, 0, 2));
        }
      }
    }

    if (form && input) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = parseFloat(String(input.value || '').replace(',', '.').replace(/[^\d.]/g, ''));
        if (isNaN(v) || v < 0.1 || v > 100) {
          if (err) err.hidden = false;
          input.setAttribute('aria-invalid', 'true');
          return;
        }
        if (err) err.hidden = true;
        input.removeAttribute('aria-invalid');
        data.runs.push({
          id: Date.now().toString(36) + Math.random().toString(36).slice(2, 6),
          km: Math.round(v * 100) / 100,
          date: new Date().toISOString()
        });
        input.value = '';
        save(data);
        render();
      });
    }
    if (reset) {
      reset.addEventListener('click', function () {
        if (!armed) {
          setArmed(true);
          return;
        }
        data.runs = [];
        save(data);
        render();
      });
    }
    render();
    return render;
  }

  /* KM 42,195: Tage bis zum nächsten Berlin-Marathon */
  function initCountdown(root) {
    each(root.querySelectorAll('[data-countdown]'), function (el) {
      var m = /^(\d{4})-(\d{2})-(\d{2})/.exec(el.getAttribute('data-countdown') || '');
      if (!m) return;
      var target = new Date(+m[1], +m[2] - 1, +m[3]);
      var days = Math.ceil((target.getTime() - Date.now()) / 86400000);
      el.textContent = fmt(Math.max(days, 0), 0, 0);
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-bl-ready')) return;
    root.setAttribute('data-bl-ready', '1');
    initToggles(root);
    var calcRender = initCalc(root);
    var trackRender = initTracker(root);
    initCountdown(root);
    root.blRerender = function () {
      if (calcRender) calcRender();
      if (trackRender) trackRender();
      initCountdown(root);
    };
  }
  function initAll() {
    each(document.querySelectorAll('[data-bl]'), init);
    hookWeglot();
  }
  var hooked = false;
  function hookWeglot() {
    if (hooked || !window.Weglot || typeof window.Weglot.on !== 'function') return;
    hooked = true;
    window.Weglot.on('languageChanged', function () {
      each(document.querySelectorAll('[data-bl]'), function (r) {
        if (r.blRerender) r.blRerender();
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.addEventListener('load', hookWeglot);
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target && e.target.querySelector ? e.target.querySelector('[data-bl]') : null);
  });
})();
